import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import store, { RootState } from '../index';
import ModalTagManageService from 'services/modalTagManage';
import { StatusCode } from 'libs/HTTP/constant';

interface IIntentionTagsStore {
  list: any[];
}
const DefalutData: IIntentionTagsStore = {
  // 列表
  list: []
};

const slice = createSlice({
  name: 'intentionTags',
  initialState: DefalutData,
  reducers: {
    setIntentionTagsList: (state, action: PayloadAction<any[]>) => {
      const { payload } = action;
      return { ...state, list: payload };
    }
  }
});
export const intentionTagsStore = (state: RootState) => state.intentionTags;
export const { setIntentionTagsList } = slice.actions;
export default slice.reducer;

// 获取意图标签列表
export const getIntentionTagsList = async () => {
  let res: any = await ModalTagManageService.getList1();
  if (res.code === StatusCode.success) {
    let list = res.data || [];
    store.dispatch(setIntentionTagsList(list));
  }
  return Promise.resolve(res);
};
